//
// DriveTimeTrafficType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var DriveTimeTrafficType = {
    NONE:0,
    HISTORICAL_AVERAGE:1,
    LIVE:2
};
export default DriveTimeTrafficType;
